var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.tx ? _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "evm_tx_tabs"
    }
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Overview")]), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "overview"
    }
  }, [_c('EVMMetadata', {
    attrs: {
      "tx": _vm.tx
    }
  })], 1)], 1)], 1)]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Transaction Details")])]);
}]

export { render, staticRenderFns }